// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import clsx from "clsx";
import { ModalType } from "../@types/modal";
import { Button, Typography } from "../index";
import { Trn } from "../../../translations/language";
import { TypographyType } from "../@types/typography";
import React, { useState, useEffect, useMemo } from "react";

function Modal(props: ModalType) {
  const { id, open, getStatus, children:ch, className, backdrop = false, backdropClosable = true  } = props;

  const [isOpen, setOpen] = useState(open);
  const [children, setChildren] = useState();

  useEffect(() => {
    setOpen(open);

  }, [open]);

  useEffect(()=>{
    setChildren(ch);

  }, [ch]);

  const handleClose = () => {
    setOpen(false);
    getStatus?.(false);
  };

  const view = useMemo(() => {
    const obj = { title: "", body: "", footer: "", header: "" };
    if (children) {
      const list = React.Children.toArray(children);
      for (const i in list) {
        //قبل از هر چیزی اول title را پیدا میکنیم
        if (list[i]?.type === Title) {
          obj["title"] = (
            <Title {...list[i]?.props}>{list[i].props?.children}</Title>
          );
          break;
        }
      }
      for (const i in list) {
        if (list[i]?.type === Body) {
          obj["body"] = (
            <Body {...list[i]?.props}>{list[i]?.props?.children}</Body>
          );
        }
        if (list[i]?.type === Footer) {
          obj["footer"] = (
            <Footer onClose={handleClose} {...list[i]?.props}>
              {list[i]?.props?.children}
            </Footer>
          );
        }
        if (list[i]?.type === Header) {
          obj["header"] = (
            <Header
              title={obj?.title}
              onClose={handleClose}
              {...list[i]?.props}
            >
              {list[i]?.props?.children}
            </Header>
          );
        }
      }
    }
    return obj;

  }, [children]);

  const handleBackdropClick = () => {
    if (backdropClosable) {
      handleClose();
    }
  };

  return (
    <>
      {isOpen && backdrop && (
        <div
          className="modal-backdrop fade show"
          style={{ zIndex: 1040 }}
        />
      )}

      <div
        id={id}
        tabIndex="-1"
        className={clsx(
          "modal fade",
          isOpen ? "show d-block" : "none",
          className
        )}
        onClick={backdrop && backdropClosable ? handleBackdropClick : undefined}
      >
        <div className="modal-dialog"  onClick={e => e.stopPropagation()}>
          <div className="modal-content">
            {view?.header}
            {view?.body}
            {view?.footer}
          </div>
        </div>
      </div>
    </>
  );
}

const Header = (props: {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  onClose: Function;
  className?: string;
  title?: React.ReactNode;
  children: React.ReactNode;
}) => {
  const { title, children, onClose, className,...other } = props;
  return (
    <div className={clsx("modal-header", className)} {...other}>
      {children ? (
        children
      ) : (
        <React.Fragment>
          {title}
          <button
            type="button"
            className="btn-close"
            onClick={() => onClose?.()}
          />
        </React.Fragment>
      )}
    </div>
  );
};

const Title = (props: { children: React.ReactNode; type?: TypographyType }) => {
  const { children, type = "h5", className, ...other } = props;
  return (
    <Typography
      type={type}
      className={clsx("modal-title", className)}
      {...other}
    >
      {children}
    </Typography>
  );
};

const Body = (props: { children: React.ReactNode }) => {
  return <div className="modal-body">{props.children}</div>;
};

const Footer = (props: {
  children: React.ReactNode;
  onClose: ()=>void;
  onSave: ()=>void;
}) => {
  const { onClose, children, onSave } = props;
  return (
    <div className="modal-footer">
      {children ? (
        children
      ) : (
        <React.Fragment>
          <Button color="primary" onClick={() => onSave?.()}>
            {Trn({ text: "save_changes" })}
          </Button>
          <Button color="secondary" onClick={() => onClose?.()}>
            {Trn({ text: "close" })}
          </Button>
        </React.Fragment>
      )}
    </div>
  );
};

Modal.Header = Header;
Modal.Title = Title;
Modal.Body = Body;
Modal.Footer = Footer;

export default Modal;
